import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "skel-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonBlock = _resolveComponent("SkeletonBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widths, (w, idx) => {
      return (_openBlock(), _createBlock(_component_SkeletonBlock, {
        key: idx,
        width: w,
        height: "12px"
      }, null, 8, ["width"]))
    }), 128))
  ]))
}